export default "__VITE_ASSET__c2a29f67__"